import type {FC, ReactNode} from 'react'
import {Paper} from '@mui/material'
import {safeShiftPaper} from '@containers/Dashboards/AgentChat/utils.ts'

interface Props {
  children: ReactNode
  /** Withdrawn by Stop before Alpinist read it (AB#6760): shown, but faded. */
  muted?: boolean
}

const UserBubble: FC<Props> = ({children, muted = false}) => {
  return (
    <Paper
      sx={{
        p: 1,
        maxWidth: '75%',
        alignSelf: 'flex-end',
        borderRadius: 2,
        bgcolor: (t) => safeShiftPaper(t, 0.06, 0.1),
        boxShadow: (t) => t.shadows[2],
        opacity: muted ? 0.55 : 1,
      }}
    >
      {children}
    </Paper>
  )
}
export default UserBubble
